import BaseController from "controllers/backend/base"

class Controller extends BaseController {
  call() {
    bindSetPasswordForm.call(this);
  }
};

const bindSetPasswordForm = function() {
  let termsAndCondition = document.querySelector('.terms-and-condition')
  let setPasswordForm = document.querySelector('.set_password.dealer')
  if (setPasswordForm != null) {
    setPasswordForm.style.visibility = 'hidden'
    let checkboxes = document.querySelectorAll('.terms_and_condition_checkbox')
    let checkboxStatuses = []

    termsAndCondition.addEventListener("change", function() {
      for (let i=0, n = checkboxes.length; i < n; i++) {
        const checkbox = checkboxes[i]
        checkboxStatuses.push(checkbox.checked)
        if (checkboxes.length == checkboxStatuses.length) {
          if (checkboxStatuses.includes(false)) {
            setPasswordForm.style.visibility = 'hidden'
          } else {
            setPasswordForm.style.visibility = 'visible'
          }
        } else {
          setPasswordForm.style.visibility = 'hidden'
        }
      }
      checkboxStatuses = []
    })
  }
};


export default Controller;
